import { useQuery } from "react-query";

import { mortgageQueryKeys } from "./queryKeys";
import useQSBuilder from "../../hooks/useQSBuilder";
import useApiHelper from "../../services/useApiHelper";
import { IMortgageEnquiry } from "../../models/mortgage/Mortgage";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";

export function useMortgagesByPerson(agencyId: string, personId: string) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const mortgages = useQuery({
    queryKey: mortgageQueryKeys.byPerson(agencyId, personId),
    queryFn: () =>
      get(
        `/mortgage/${agencyId}${buildQs({ personId })}`
      ) as unknown as IDefaultResponseWithData<IMortgageEnquiry[]>,
    refetchOnWindowFocus: false,
  });

  return {
    mortgages,
  };
}
